import { axios } from '~/plugins/axios'

const actions = {
  async fetchReport(_, payload) {
    const resp = await axios.post('/api/reports/prompter-search-results', payload)
    return resp.data
  },

  async fetchSummary(_, payload) {
    const resp = await axios.post('/api/reports/prompter-search-results/summary', payload)
    return resp.data
  },

  async searchTopics(_, { projectId, search, page = 1, limit = 20 }) {
    const query = `{
      knowledgeTopics(project_id: ${Number(projectId)}, search: ${JSON.stringify(search || '')}, page: ${page}, limit: ${limit}) {
        data {
          id
          title
        }
        total
        current_page
        last_page
      }
    }`

    const resp = await axios.post('/api/graphql', { query })
    return (resp.data && resp.data.data && resp.data.data.knowledgeTopics) || { data: [] }
  },

  async updateExpectedTopic(_, { id, expectedTopicId }) {
    const resp = await axios.patch(`/api/prompter/search-results/${id}`, {
      expected_topic_id: expectedTopicId,
    })
    return resp.data
  },

  async updateIsCorrect(_, { id, isCorrect }) {
    const resp = await axios.patch(`/api/prompter/search-results/${id}`, {
      is_correct: isCorrect,
    })
    return resp.data
  },
}

export default {
  namespaced: true,
  actions,
}
